import { normalisiereDokument } from './bearbeiten';
import { dokumentZuText } from './htmlExport';
import { schreibeVertragsdokument } from './lesen';
import { Vertragsdokument } from './types';

/** Gleiche Grenze wie CONTRACT_TEMPLATE_DOCUMENT_MAX_BYTES im Backend (contractTemplateDocument.ts). */
export const DOKUMENT_MAX_BYTES = 512 * 1024;

/** Komposition und leere Bearbeitungsabsätze in Kopf/Fuß gehören nicht zum gespeicherten Stand. */
export function speicherdokument(zustand: {
  dokument: Vertragsdokument;
  komposition: { vorher: { dokument: Vertragsdokument } } | null;
}): Vertragsdokument {
  return normalisiereDokument(zustand.komposition?.vorher.dokument ?? zustand.dokument);
}

export function speicherText(dokument: Vertragsdokument): string {
  return schreibeVertragsdokument(dokument);
}

/** UTF-8-Länge ohne Browserabhängigkeit; einzelne Surrogate zählen als Ersatzzeichen (drei Bytes). */
export function utf8Bytes(wert: string): number {
  let anzahl = 0;
  for (let index = 0; index < wert.length; index += 1) {
    const zeichen = wert.charCodeAt(index);
    if (zeichen <= 0x7f) anzahl += 1;
    else if (zeichen <= 0x7ff) anzahl += 2;
    else if (
      zeichen >= 0xd800 &&
      zeichen <= 0xdbff &&
      wert.charCodeAt(index + 1) >= 0xdc00 &&
      wert.charCodeAt(index + 1) <= 0xdfff
    ) {
      anzahl += 4;
      index += 1;
    } else anzahl += 3;
  }
  return anzahl;
}

/** Nur der Vertragstext zählt; dieselbe Leer-Prüfung wie `hasVisibleText` im Backend. */
export function hatSichtbarenText(dokument: Vertragsdokument): boolean {
  return (
    dokumentZuText(dokument)
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .trim().length > 0
  );
}
